// extracted by mini-css-extract-plugin
export var divider = "_ty-0";